import $ from "jquery"
import { debounce } from "../../util/dom"

export function initializeCollapseComponent(): void {
  $(() => {
    $(document).on("click", ".collapse-show", function (event: JQuery.Event) {
      event.preventDefault()

      const container = $(this).closest(".collapse-container")
      container.find(".collapse-hide").show()
      container.find(".collapse-show").hide()
      container.find(".collapse-text-full").show()
      container.find(".collapse-text-short").hide()
    })
    $(document).on("click", ".collapse-hide", function (event: JQuery.Event) {
      event.preventDefault()

      const container = $(this).closest(".collapse-container")
      container.find(".collapse-hide").hide()
      container.find(".collapse-show").show()
      container.find(".collapse-text-full").hide()
      container.find(".collapse-text-short").show()

      toggleClampedCollapseButton(container)
    })

    function toggleClampedCollapseButtons() {
      $(".collapse-container.collapse-clamped").map(function () {
        toggleClampedCollapseButton($(this))
      })
    }

    toggleClampedCollapseButtons()
    $(window).on("resize", debounce(toggleClampedCollapseButtons, 50))
  })
}

function toggleClampedCollapseButton(container: JQuery) {
  if (!container.hasClass("collapse-clamped")) {
    return
  }

  const shortTextContainer = container.find(".collapse-text-short")
  if (shortTextContainer.is(":hidden")) {
    return
  }

  const height = shortTextContainer.height() ?? 0
  const scrollHeight = shortTextContainer.get(0)!.scrollHeight
  const isClamped = height < scrollHeight
  shortTextContainer.siblings(".collapse-show").toggle(isClamped)
}
